enum ToastStyle {
  ERROR,
  SUCCESS,
}

export default ToastStyle;
